<template>
    <v-row no-gutters>
        <v-col col="12">
            <ObjectTasksList
                :client="client"
                :project="project"
                @fetched-tasks="loaded = true"
                @clone_project="$emit('clone_project')"
            />
            <template v-if="taskCount === 0 && loaded">
                <v-row align="center" justify="center" class="mt-5">
                    <div class="text-center mt-5">
                        <div class="mb-2 display-1">
                            {{
                                isEventTypeCompany(project.account_id) ? $t("Create event workflow") : $t('Create project workflow')
                            }}
                        </div>
                        <div class="subtitle-1 grey--text">
                            {{ $t("Use workflow templates to set up tasks effectively or") }}
                        </div>
                        <p class="body-2 mt-1">
                            <a class="text-no-decor font-weight-medium" @click="new_task()">+
                                {{ $t("Add tasks manually") }}</a>
                        </p>
                        <v-btn large color="primary" class="inverted--text elevation-0" @click.native="editWorkflow">
                            <v-icon left size="24">add</v-icon>
                            <span class="font-weight-bold">{{ $t("Choose template") }}</span>
                        </v-btn>
                    </div>
                </v-row>
            </template>
        </v-col>
    </v-row>
</template>

<script>
import ObjectTasksList from "@/views/Task/ObjectTasksList";
import TaskModule from "@/store/modules/task";
import {computed, ref} from "@vue/composition-api";
import ProjectModule from "@/store/modules/project";

export default {
    name: "ProjectTasks",
    components: {
        ObjectTasksList
    },
    props: {
        client: {
            type: Object,
            default: null
        },
        project: {
            type: Object,
            default: null
        }
    },
    setup(props, ctx) {
        const loaded = ref(false)
        const { isEventTypeCompany } = ProjectModule()

        const {
            openTask,
            tasks_list
        } = TaskModule();
        const a = TaskModule()

        const new_task = () => {
            openTask(0, {
                project_id: props.project.id,
                client_id: props.project.client_id
            });
        };

        const taskCount = computed(() => tasks_list.value.length)

        const editWorkflow = () => {
            ctx.root._router.push({ name: "project_edit_workflow", params: { id: props.project.id, action: 'none' }});
        };

        return {
            taskCount,
            new_task,
            editWorkflow,
            loaded,
            a,
            isEventTypeCompany
        }
    }
}
</script>

<style scoped>

</style>